//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { InstaShopAutoApprovalSources } from '@galleries/models/galleriesStateModel';
import ClientId from '@models/ClientId';
import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';
import ReelId from '@models/ReelId';
import { SocialNetwork } from '@models/SocialNetwork';
import UserId from '@models/UserId';

export enum ReelAutoApprovalSourceType {
  instagramUser = 'instagramUser',
  instagramBusinessUser = 'instagramBusinessUser',
  instagramHashtag = 'instagramHashtag',
}

export interface IAutoApprovalConfiguration {
  id: number;
  sourceId?: InstagramBusinessAccountId;
  sourceNetwork: SocialNetwork;
  destinationReelId: ReelId;
  autoApprovalStrategy: InstaShopAutoApprovalSources;
  sourceType: ReelAutoApprovalSourceType;
  curalateUserId: UserId;
  curalateClientId: ClientId;
  createdAt: number;
  lastUpdated: number;
  isDeleted: boolean;
}
